import React, {useEffect, useState} from "react";
import './AsignarUnidades.scss'
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputText} from 'primereact/inputtext';
import {
    asignarUnidad,
    desvincularDB,
    ESTATUS_EMPRESARIAL,
    desvincularOperadoresInactivos,
    getUnidades,
    getUnidadesDisponibles
} from "./integracion";
import Boton from "../../../components/atoms/Boton/Boton";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import Swal from "sweetalert2";

const AsignarUnidades = () => {


    const [globalFilter, setGlobalFilter] = useState('');
    const [actualizar, setActualizar] = useState(false);
    const [unidades, setUnidades] = useState([]);
    const [dataTable, setDataTable] = useState([]);
    const [assignDialog, setAssignDialog] = useState(false)
    const [driver, setDriver] = useState(null);
    const [selectedUnidad, setSelectedUnidad] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);


    // funciones de integracion
    useEffect(() => {
        getUnidades(setDataTable);
        getUnidadesDisponibles(setUnidades);
    }, [actualizar])


    const desvincular = (id_operador, id_unidad) => {
        desvincularDB(id_operador, id_unidad, setActualizar, actualizar)
    }


    // todo lo relacionado con la datatable

    const camion = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCCQWWlMucxfnoKmV-wG-AfIsl5UudCo5zOC0Yq8IjlA&s"
    const sprinter = 'https://acroadtrip.blob.core.windows.net/catalogo-imagenes/l/RT_V_40a45236dd224a3c89498018c3e9e554.jpg'

    const desvincularOperadores = async () => {
        setLoading(true);
        desvincularOperadoresInactivos()
            .then(() => {
                setLoading(false);
                setActualizar(!actualizar);
            })
            .catch(() => setLoading(false));
    };

    const header = (

        <div className="table-header">
            <div style={{alignContent: 'center'}}>
                <Button label="Desvincular unidades de operadores inactivos" loading={loading} onClick={desvincularOperadores} />
            </div>
            <div>
                <h5>Filtrar</h5>
                <InputText
                    type="search"
                    onInput={(e) => setGlobalFilter(e.target.value)}
                    placeholder="Buscar"
                />
            </div>
        </div>
    );
    const bodyTemplateImage = (rowData) => {
        return (
            <span>
                {
                    rowData.imagen ?
                        <>
                            <img src={"https://servicios.sumaenlinea.mx/Imagenes/" + rowData.imagen} alt="Car"
                                 className="imagenDatatable"/>
                        </> :
                        <>
                            <img
                                src={"https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg"}
                                alt="Car" className="imagenDatatable"/>
                        </>

                }
            </span>
        );
    };
    const globalFilterFunction = (value, filter) => {
        if (!filter) return true;
        return value.toString().toLowerCase().includes(filter.toLowerCase());
    };

    const assignUnit = (product) => {
        setDriver({...product});
        setAssignDialog(true);
    };

    const hideDialog = () => {
        setAssignDialog(false);
    };

    const saveProduct = async () => {
        if (!selectedUnidad) return;

        const requiereCambioEstatus = Number(selectedUnidad.estatus) !== ESTATUS_EMPRESARIAL;

        if (requiereCambioEstatus) {
            setAssignDialog(false);
            const confirm = await Swal.fire({
                icon: 'warning',
                title: 'Cambio de estatus',
                text: `La unidad ${selectedUnidad.code} no tiene estatus EMPRESARIAL. Al asignarla, su estatus cambiará a EMPRESARIAL.`,
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
            });

            if (!confirm.isConfirmed) {
                setAssignDialog(true);
                return;
            }
        }

        await asignarUnidad(
            driver.operador_id,
            selectedUnidad.code,
            setActualizar,
            actualizar,
            requiereCambioEstatus ? ESTATUS_EMPRESARIAL : null
        )
        setSelectedUnidad(null);
        setAssignDialog(false);
    }


    const productDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" outlined onClick={hideDialog}/>
            <Button label="Asignar" icon="pi pi-check" onClick={saveProduct}/>
        </React.Fragment>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                {
                    rowData.id_unidad.includes("SIN ASIGNAR") ? (
                        rowData.asignar ? (
                            <Button
                                label="Vincular"
                                onClick={() => assignUnit(rowData)}
                            />
                        ) : 'No hay acciones disponibles'
                    ) : (
                        <Boton
                            onClick={() => desvincular(rowData.operador_id, rowData.id_unidad)}
                        >
                            Desvincular
                        </Boton>
                    )
                }
            </div>
        );
    };


    const selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <div className="select-image">
                    <img alt={option.image} src={"https://sumaenlinea.mx/Imagenes/" + option.image}
                         style={{width: '18px'}}/>
                    <div>{`${option.code} - ${option.name}`}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplate = (option) => {
        return (
            <div className="select-image">
                <img alt={option.image} src={"https://sumaenlinea.mx/Imagenes/" + option.image}
                     style={{width: '18px'}}/>
                <div>{`${option.code} - ${option.name}`}</div>
            </div>
        );
    };


    return (
        <div className="AsignarUnidades">
            <div>
                <div>
                    <DataTable value={dataTable}
                               header={header}
                               globalFilter={globalFilter}
                               scrollable
                               scrollHeight="calc(100vh - 230px)"
                               globalFilterFunction={globalFilterFunction}
                               size='small'
                               paginator
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        // first={first}
                               rows={25}
                        // totalRecords={totalRecords}
                        // onPage={onPageChange}
                               rowsPerPageOptions={[25, 50, 100]}>
                        <Column field='operador_nombre' header="Operador"/>
                        <Column field="id_unidad" header="Unidad"/>
                        <Column field="tipo_de_unidad" header="Vehículo"/>
                        <Column field="asientos" header="Asientos"/>
                        <Column body={bodyTemplateImage} header="Imagen" className="column"/>
                        <Column body={actionBodyTemplate}/>
                    </DataTable>
                </div>
            </div>
            <Dialog visible={assignDialog} style={{width: '32rem'}} breakpoints={{'960px': '75vw', '641px': '90vw'}}
                    header="Unidades disponibles" modal className="p-fluid" footer={productDialogFooter}
                    onHide={hideDialog}>
                <div className="card flex justify-content-center">
                    <Dropdown value={selectedUnidad}
                              onChange={(e) => setSelectedUnidad(e.value)}
                              options={unidades}
                              optionLabel="name"
                              placeholder="Selecciona una unidad"
                              filter
                              filterBy="code,name"
                              valueTemplate={selectedCountryTemplate}
                              itemTemplate={countryOptionTemplate}
                              className="w-full md:w-14rem"/>
                </div>
            </Dialog>
        </div>
    )
}
export default AsignarUnidades